import React from 'react';
import { Helmet } from 'react-helmet';
import HeroSection from './components/HeroSection';
import WhatWeDoSection from './components/WhatWeDoSection';
import HowItWorksSection from './components/HowItWorksSection';
import WhoItsForSection from './components/WhoItsForSection';
import WhyDifferentSection from './components/WhyDifferentSection';
import FooterSection from './components/FooterSection';

const Homepage = () => {
  return (
    <>
      <Helmet>
        <title>MycoMind - AI-Powered Healthcare Platform</title>
        <meta 
          name="description" 
          content="Bridging the gap between patients and providers with AI. MycoMind transforms daily health data into actionable insights for personalized care." 
        />
        <meta name="keywords" content="healthcare, AI, neurology, patient care, symptom tracking, cognitive games" />
      </Helmet>
      
      <div className="min-h-screen bg-background">
        <HeroSection />
        <WhatWeDoSection />
        <HowItWorksSection />
        <WhoItsForSection />
        <WhyDifferentSection />
        <FooterSection />
      </div>
    </>
  );
};

export default Homepage;